import * as React from 'react';
import {RecipeObject} from 'api/recipe/types';
import {Builder, BuilderProps} from 'components/Builder';
import Tabbar from 'components/Tabbar';
import Tab from 'components/Tab';
import {Settings} from './components/Settings';
import {Content} from './components/Content';

/**
 * The component create or update recipe object.
 * @param {Omit<BuilderProps<RecipeObject>, 'children'>} props
 * @return {React.ReactElement<Omit<BuilderProps<RecipeObject>, 'children'>>}
 * @constructor
 */
export default function RecipeBuilder(
    props: Omit<BuilderProps<RecipeObject>, 'children'>,
): React.ReactElement<Omit<BuilderProps<RecipeObject>, 'children'>> {
  return (
    <Builder<RecipeObject> {...props}>
      {{
        content: (
          <React.Fragment>
            <Settings />
            <br/>
            <Content />
          </React.Fragment>
        ),
        footer: (options) => (
          <Builder.Footer {...options} />
        ),
      }}
    </Builder>
  );
}
